import { useEffect, useState } from "react";
import FormFactory from "../../../components/FormFactory";

function ExitForm({ schema, object, onSubmitForm, goBack, isDisabled }) {
  const [formData, setFormData] = useState({ ...object });

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  const onSubmit = (e) => {
    e.preventDefault();
    onSubmitForm(formData);
  };

  const onChange = (value, field) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <>
      <div>
        <form onSubmit={onSubmit}>
          <div className="row g-3">
            <FormFactory
              disabled={isDisabled}
              schema={schema}
              object={object}
              onChange={onChange}
            />
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="btn text-white fs-sm me-3"
              style={{ backgroundColor: "#d18237" }}
            >
              <i className="bi bi-file-earmark-check me-2"></i>SAVE
            </button>
            <button
              type="button"
              className="btn btn-light fs-sm"
              onClick={goBack}
            >
              GO BACK
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ExitForm;
